<!--
 * @Author:
 * @Description: 网关详情
-->
<template>
  <CockpitDialog
    class="left-520px top-300px text-white !text-opacity-80"
    title="网关详情"
    @close="close"
  >
    <el-row :span="24" class="mb-10px">
      <el-col :span="6" class="text-right text-white !text-opacity-50">imei：</el-col>
      <el-col :span="18">{{ propsData.imei }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="text-right mb-10px text-white !text-opacity-50">网关名称：</el-col>
      <el-col :span="18">{{ propsData.gwName }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="text-right text-white !text-opacity-50">在线状态：</el-col>
      <el-col :span="18">{{ propsData.onlineState === 0 ? '离线' : '在线' }}</el-col>
    </el-row>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'

export default {
  name: 'gatewayDetailDialog',
  components: {
    CockpitDialog,
  },
  props: {
    propsData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {}
  },
  watch: {},
  created() {},
  methods: {
    close() {
      this.$emit('refresh', false)
    },
  },
}
</script>

<style lang="scss" scoped></style>
